import VueRouter from "vue-router";
import routes from "./routes";
import util from "../util/util";

function checkInactivity() {
  let timer;
  window.clearTimeout(timer);
  timer = window.setTimeout(() => {
    console.log("logout");
    alert("Inactivity  for 5 minutes");
    util.logoutOnRefresh();
  }, 5000);
}

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 1000);
    });
  }
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = sessionStorage.getItem("token");
  if (authRequired && loggedIn == null) {
    console.log("NOT AUTH");
    return next("/login");
  } else if (loggedIn != null) {
    // checkInactivity()
  }
  
  next();
});

export default router;
